var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeTrackerEvent',{attrs:{"dto_model":"TimeTrackerEventDateAggregateDTO"}})
}
var staticRenderFns = []

export { render, staticRenderFns }